var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import 'antd/lib/input/style/index.css';
var formStyles = require('src/imports/styles/extend.form.scss');
var InputCountryState = (function (_super) {
    __extends(InputCountryState, _super);
    function InputCountryState(props) {
        var _this = _super.call(this, props) || this;
        var charCount = 20;
        if (_this.props.initialValue) {
            charCount -= _this.props.initialValue.length;
        }
        _this.state = {
            charCount: charCount,
        };
        return _this;
    }
    InputCountryState.prototype.updateCharCount = function (value) {
        if (value.length >= 20) {
            this.setState({
                charCount: 0,
            });
        }
        else {
            this.setState({
                charCount: 20 - value.length,
            });
        }
    };
    InputCountryState.prototype.render = function () {
        var _this = this;
        return (React.createElement(Form.Item, { label: React.createElement("span", { className: formStyles.optional }, "State, Province or City"), extra: "Max. 20 characters, " + this.state.charCount + " left.", colon: false }, this.props.form.getFieldDecorator('countryState', {
            initialValue: this.props.initialValue || '',
            rules: [{
                    max: 20,
                    message: 'State, province or city name is too long',
                }, {
                    type: 'string',
                }],
        })(React.createElement(Input, { size: 'large', disabled: this.props.isDisabled, autoComplete: 'off', onChange: function (e) { return _this.updateCharCount(e.target.value); } }))));
    };
    return InputCountryState;
}(React.Component));
export default InputCountryState;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormAthletePage/FormAthlete/InputCountryState.tsx
// module id = 1204
// module chunks = 0